import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";

const InputDatePicker = ({
  date,
  setDate,
  intervention,
  heading,
  issueId,
  dateType,
  className,
  height,
  disabled,
  style,
  noOffset,
  maxDate,
  minDate,
}) => {
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
      className={`mw-100 px-2 rounded datePicker py-1${
        noOffset ? "" : " ml-[-50px]"
      }${className ? ` ${className}` : ""}`}
      onClick={setDate && onClick}
      ref={ref}
      disabled={disabled || (className == "disabled-bg" && true)}
      style={
        height
          ? {
              height,
              ...style,
              backgroundColor: disabled ? "#e9ecef" : "white",
              cursor: disabled ? "not-allowed" : "pointer",
            }
          : {
             ...style,
              backgroundColor: disabled ? "#e9ecef" : "white",
              cursor: disabled ? "not-allowed" : "pointer",
            }
      }
    >
      <small className="f-10">{value ? value : <b />}</small>
      <div className="float-right">
        <small>
          <i className="fa fa-calendar text_primary f-13" />
        </small>
      </div>
    </button>
  ));

  return (
    <DatePicker
      selected={date}
      onChange={(date) =>
        intervention != null
          ? setDate(date, intervention, heading, issueId)
          : setDate(date, dateType, heading, issueId)
      }
      customInput={<ExampleCustomInput />}
      dateFormat="dd MMM yyyy"
      maxDate={maxDate}
      minDate={minDate}
    />
  );
};

export default InputDatePicker;
